<template>
    <v-bottom-sheet v-model="$store.state.bookingSelectEmployeDialogStatus" hide-overlay elevation="0">
      <v-card color="white" rounded="t-xl">
        <v-card-text class="px-1 pt-0">
          <v-row justify="center">
            <v-col cols="12" md="6">
              <v-card variant="text">
                <v-card-actions>
                  <h3>{{ $t('select_employe') }}</h3>
                  <v-spacer></v-spacer>
                  <v-btn icon @click="$store.commit('setBookingSelectEmployeDialogStatus', false)">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-card-actions>
                <v-divider></v-divider>
                <v-card-text class="px-1">
                  <v-row
                    v-if="!!$store.state.service && !!$store.state.serviceEmployees && $store.state.serviceEmployees.length > 0">
                    <v-col cols="12" md="6"
                      v-for="(employe, index) in $store.state.serviceEmployees"
                      :key="index">
                      <v-card class="pa-2" color="white" elevation="3" rounded="lg">
                        <div class="d-flex flex-column text-center">
                          <div class="d-flex align-center justify-space-between text-center">
                            <div class="d-flex align-center">
                              <v-avatar class="mr-4">
                                <v-img :src="$store.state.fileBaseUrl+employe.image" cover />
                              </v-avatar>
                              <h4 class="mr-4">{{ employe.title }}</h4>
                            </div>
                            <p v-if="!!employe.description" v-html="employe.description.replaceAll('\n','<br/>')"></p>
                          </div>
                          <v-btn color="primary" variant="outlined" rounded="lg" class="mt-4"
                            @click="$store.commit('setEmploye', employe); $store.commit('setBookingDialogStatus', true); $store.commit('setBookingSelectEmployeDialogStatus', false);">
                            {{ $t('select_and_continue') }}
                          </v-btn>
                        </div>
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-alert v-else type="warning" elevation="3">
                    {{ $t('no_employes_available') }}
                  </v-alert>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-bottom-sheet>
  </template>
  
  <script>
  export default {
    name: "SubmitBookingPage",
  }
  </script>
  
  <style>
  .v-slide-group__next,
  .v-slide-group__prev {
    min-width: 30px !important;
  }
  </style>
  